import React, { Component } from 'react'
import Bodymovin from 'lottie-web'

import loadingAnimation from 'animations/loading'

let animation

class Loading extends Component {

	render() {
		return <div ref='el'></div>
	}

	componentDidMount() {
		animation = Bodymovin.loadAnimation({
			animationData: loadingAnimation,
			wrapper: this.refs.el,
			loop: true,
			animType: 'svg',
			autoplay: true,
		})
	}

	componentWillUnmount() {
		animation.destroy()
	}

}

export default Loading
